export default __webpack_public_path__ + "static/media/wallet-card-theme7.0337e594.svg";